import React from 'react';
import styles from './ContactUs.module.css';

function ContactUs() {
    return (
        <div className={styles.contactUsPageContainer}>
            <h3>Contact Us</h3>
            <p className={styles.bodyM}>
                For any queries, help or complaints, please reach out to puneet.gurtoo@gojek.com
            </p>
        </div>
    );
}

export default ContactUs;
